import Cookies from "cookie-universal";
import ReactDOM from "react-dom/client";
import App from "./app.js";
import { initGA } from "./utils/ga/google-analytics.js";

const root = document.getElementById("root");

if (!root) {
    throw new Error("Could not find root element");
}

initGA();

const cookies = Cookies();

ReactDOM.createRoot(root).render(<App url={location.href} cookies={cookies} />);
